import { Button, Col, Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { CheckOutlined, CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, HistoryOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ConfimLottery_Period_Api, DoLottery_Period_Api, GetAllReserves_Period_Api, GetById_Period_Api } from '../../API/PeriodApi';
import { ReserveStatus } from '../Reserve/ReserveStatus';
import { ReservesGrid } from '../Reserve/ReservesGrid';
import ColumnGroup from 'antd/es/table/ColumnGroup';
// ======================================================================

export const PeriodReservesComponent = ({
    setLoading,
    showMessage,
    periodId,
    periodTitle,
    onBackClick,
    onItemClick,
    isShowLotteryButton = false
}) => {
    // ======================================================================
    const [period, setPeriod] = useState();
    const [subPeriods, setSubPeriods] = useState(0);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    const loadData = async () => {
        await loadPeriod();

        loadSubPeriods();
    }
    // ======================================================================
    const loadSubPeriods = async () => {
        setLoading(true);
        try {
            const data = await GetAllReserves_Period_Api(periodId);
            if (data.messageStatus == "Successful") {
                setSubPeriods(data.messageData.data);
                setLoading(false);
            }
            else {
                showMessage(data.message, "error")
                setLoading(false);
            }
        }
        catch (error) {
            showMessage("خطا در ارتباط با سرور.", "error");
            setLoading(false);

        }
    }
    // ======================================================================
    const loadPeriod = async () => {
        setLoading(true);
        try {
            const data = await GetById_Period_Api(periodId);
            if (data.messageStatus == "Successful") {
                setPeriod(data.messageData.data);
                setLoading(false);

            }
            else {
                showMessage(data.message, "error")
                setLoading(false);

            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const DoLottery = async () => {
        setLoading(true);
        try {
            const data = await DoLottery_Period_Api(periodId);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                await loadData();
                setLoading(false);
            }
            else {
                showMessage(data.message, "error")
                setLoading(false);
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const ConfimLottery = async () => {
        setLoading(true);
        try {
            const data = await ConfimLottery_Period_Api(periodId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                await loadData();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    // ======================================================================
    return (
        <>
            {period ?
                <>
                    <Row className='sectionTitle'>
                        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                            <Button onClick={() => onBackClick()}>
                                <DoubleRightOutlined />
                                بازگشت
                            </Button>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                            <h2 >
                                ثبت نام های {period?.title}
                            </h2>
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={10} xl={10} style={{ textAlign: "left" }}>
                            {isShowLotteryButton ?
                                <>
                                    <Button
                                        className='btn-info'
                                        htmlType="submit"
                                        onClick={
                                            () => {
                                                Modal.confirm({
                                                    title: 'آیا از انجام قرعه کشی اطمینان دارید؟',
                                                    onOk: () => { DoLottery() },
                                                    footer: (_, { OkBtn, CancelBtn }) => (
                                                        <>
                                                            <CancelBtn />
                                                            <OkBtn />
                                                        </>
                                                    ),
                                                });
                                            }}
                                        disabled={period.lotteryStatus == "LotteryConfirmed"}
                                        style={{ marginLeft: '5px' }}
                                    >
                                        <HistoryOutlined />
                                        قرعه کشی
                                    </Button>
                                    <Button
                                        disabled={period.lotteryStatus != "LotteryCompleted"}
                                        className='btn-success'
                                        htmlType="submit"
                                        onClick={
                                            () => {
                                                Modal.confirm({
                                                    title: 'آیا از تایید قرعه کشی اطمینان دارید؟',
                                                    onOk: () => { ConfimLottery() },
                                                    footer: (_, { OkBtn, CancelBtn }) => (
                                                        <>
                                                            <CancelBtn />
                                                            <OkBtn />
                                                        </>
                                                    ),
                                                });
                                            }
                                        }
                                    >
                                        <CheckOutlined />
                                        تایید قرعه کشی
                                    </Button>

                                </>
                                : <></>
                            }
                        </Col>
                    </Row>
                    {subPeriods ?
                        <>
                            {subPeriods.map((subPeriod, key) =>
                                <>

                                    {
                                        subPeriod.objectInstances.map((objectInstance, key) =>
                                            <>
                                                <ReservesGrid
                                                    reserves={objectInstance.reserves}
                                                    rowNumber={1}
                                                    objectInstance={objectInstance}
                                                    onItemClick={onItemClick}
                                                />
                                            </>
                                        )
                                    }
                                </>
                            )}
                        </>
                        : <></>
                    }


                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >

                        </Col>
                    </Row>
                </> : <></>
            }
        </>
    )
}
